"use client";

import gql from "graphql-tag";
import type {
  ManagePromEvent,
  ManagePromInput,
  ManagePromResponse,
  ManagePromV2Event,
  ManagePromV2Input,
  ManagePromV2Response,
} from "@rmh/defs";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";

export interface ManagePromMutationVariables {
  event: ManagePromEvent;
  input: ManagePromInput;
}

export const managePromMutation = gql`
  mutation manageProm($event: ManagePromEvent!, $input: ManagePromInput!) {
    manageProm(event: $event, input: $input) {
      success
      error {
        message
        details
      }
      data {
        episodeOfCareId
        promItems {
          index
          status
          responses
          appointmentType
        }
      }
    }
  }
`.loc?.source.body as GeneratedMutation<
  ManagePromMutationVariables,
  {
    manageProm: ManagePromResponse;
  }
>;

export interface ManagePromV2MutationVariables {
  event: ManagePromV2Event;
  input: ManagePromV2Input;
}

export const managePromV2Mutation = gql`
  mutation managePromV2(
    $event: ManagePromV2Event!
    $input: ManagePromV2Input!
  ) {
    managePromV2(event: $event, input: $input) {
      success
      error {
        message
        details
      }
    }
  }
`.loc?.source.body as GeneratedMutation<
  ManagePromV2MutationVariables,
  {
    managePromV2: ManagePromV2Response;
  }
>;
